import React from 'react';
import ArchiveApprovalsComponent from '../ArchiveApprovals';
import Heading from '@hubins/components/Heading';

const ApprovalsArchived = () => {
  return (
    <>
      <Heading size="3" className='s-top-xl s-bottom-md'>Archive</Heading>
      <ArchiveApprovalsComponent />
    </>
  );
};

export default ApprovalsArchived;
